import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const languages = [
  { code: "en", key: "lang.en", flag: "en" },
  { code: "fr", key: "lang.fr", flag: "fr" },
  { code: "da", key: "lang.da", flag: "da" },
  { code: "de", key: "lang.de", flag: "de" },
];

export default function LanguageSwitcher({ light = false }: { light?: boolean }) {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const current = languages.find((l) => l.code === (i18n.language || "en")) || languages[0];

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className={`flex items-center gap-1.5 whitespace-nowrap rounded-md px-2.5 py-1.5 text-sm font-medium transition-colors cursor-pointer ${
          light ? "text-white hover:bg-white/10" : "text-foreground-700 hover:bg-background-100"
        }`}
      >
        <i className="ri-global-line text-base w-4 h-4 flex items-center justify-center"></i>
        <span>{t(current.key)}</span>
        <i className="ri-arrow-down-s-line text-sm w-4 h-4 flex items-center justify-center"></i>
      </button>

      {open && (
        <div className="absolute right-0 z-50 mt-2 w-44 overflow-hidden rounded-lg border border-background-300 bg-white py-1">
          {languages.map((l) => (
            <button
              key={l.code}
              type="button"
              onClick={() => {
                i18n.changeLanguage(l.code);
                setOpen(false);
              }}
              className={`flex w-full items-center justify-between whitespace-nowrap px-4 py-2 text-left text-sm transition-colors cursor-pointer ${
                i18n.language === l.code
                  ? "bg-primary-50 font-semibold text-primary-700"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              <span>{t(l.key)}</span>
              {i18n.language === l.code && (
                <i className="ri-check-line text-sm w-4 h-4 flex items-center justify-center text-primary-600"></i>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}